/**
 * ================================================================
 * Bisou Rivage V5 — bisou-variant-ui.js
 * ================================================================
 *
 * Trois modules autonomes (IIFE) :
 *
 *   1. VARIANT UI
 *      Selecteur format / cadre / couleur, synchronisation avec
 *      les <select> natifs Shopify, mise a jour du prix, du stock
 *      et du bouton ATC.
 *
 *   2. S2 SCROLL ACCELERE
 *      La section "Associe le" remonte 1.3x plus vite que le
 *      scroll normal pour un effet de reveal (desktop >= 900 px).
 *
 *   3. ASSOCIATED PRODUCTS
 *      Fetch des recommandations Shopify, filtrage par orientation
 *      (V-/H- dans le titre), affichage de 2 cards max et synchro
 *      des images avec le variant principal.
 *
 * ================================================================
 */


/* ================================================================
   1. VARIANT UI
   ================================================================ */
(function () {
  'use strict';

  var fmtList = document.getElementById('rv5-bloc-fmt');
  if (!fmtList) return;

  /* ── 1.0  Bridge lang (injecté par Liquid, avec fallbacks FR) ── */
  var VCFG = (window.BISOU_VARIANT_CFG && window.BISOU_VARIANT_CFG.lang) || {};

  /* ── 1.1  Constantes ─────────────────────────────────────────── */

  /** Labels affiches pour chaque couleur de cadre */
  var LABELS = {
    'none':    VCFG.frameNone    || 'Sans cadre',
    'noir':    VCFG.frameBlack   || 'Cadre Noir',
    'blanc':   VCFG.frameWhite   || 'Cadre Blanc',
    'chene':   VCFG.frameOak     || 'Cadre Ch\u00eane',
    'bouleau': VCFG.frameBirch   || 'Cadre Bouleau'
  };

  /** Suffixe taille cadre utilise dans le titre du variant Shopify */
  var VARIANT_FRAME_SIZES = {
    A2: '50x70cm',
    A3: '40x50cm',
    A4: '30x40cm'
  };

  /* ── 1.2  Donnees injectees par Liquid (data-attributes) ─────── */

  /** Le plafond de l'edition POUR UN FORMAT, pose par
   *  snippets/bisou-variant-ui.liquid. Dix exemplaires par format, partages
   *  entre les cinq finitions — pas dix par variante. */
  var QUOTA = parseInt(fmtList.dataset.quota, 10) || 10;

  /** Le reste d'un format, ou null quand il n'est pas connu.
   *  snippets/br-remaining.liquid rend une chaine VIDE plutot qu'un nombre
   *  invente : « 0 » veut dire epuise, « » veut dire tais-toi. Le vieux
   *  `parseInt(...) || 0` confondait les deux et affichait « Epuise ». */
  function readRemaining(raw) {
    if (raw === undefined || raw === null) return null;
    var s = String(raw).trim();
    if (s === '') return null;
    var n = parseInt(s, 10);
    if (isNaN(n)) return null;
    if (n < 0) n = 0;
    if (n > QUOTA) n = QUOTA;
    return n;
  }

  var remaining = {
    A2: readRemaining(fmtList.dataset.remainingA2),
    A3: readRemaining(fmtList.dataset.remainingA3),
    A4: readRemaining(fmtList.dataset.remainingA4)
  };

  /** Le numero du prochain tirage vendu dans ce format.
   *  Il se deduit du QUOTA DU FORMAT, jamais du stock brut Shopify :
   *  dix moins ce qui reste, plus un. Il est attribue A L'ACHAT — le panier
   *  ne le reserve pas (decision de Max, 26/08). */
  function printNumber(r) {
    return QUOTA - r + 1;
  }

  var prices = {
    A2: { cadre: parseInt(fmtList.dataset.priceA2Cadre) || 0, sans: parseInt(fmtList.dataset.priceA2Sans) || 0 },
    A3: { cadre: parseInt(fmtList.dataset.priceA3Cadre) || 0, sans: parseInt(fmtList.dataset.priceA3Sans) || 0 },
    A4: { cadre: parseInt(fmtList.dataset.priceA4Cadre) || 0, sans: parseInt(fmtList.dataset.priceA4Sans) || 0 }
  };

  var sectionId = fmtList.dataset.sectionId;

  /* ── 1.2.b  Lookup variants (fallback fiable iPad Safari) ─────── */
  var variants = [];
  try {
    var varScript = document.getElementById('rv5-variants-' + sectionId);
    if (varScript) variants = JSON.parse(varScript.textContent);
  } catch (e) { variants = []; }

  /* Trouve l'ID du variant correspondant a l'etat courant (format + cadre + couleur) */
  function findVariantId() {
    if (!variants.length) return null;
    var fmt = state.format.toLowerCase();
    var isNone = !state.withFrame || state.color === 'none';
    var col = state.color;
    var cFr = col === 'chene' ? 'ch\u00eane' : col;
    var cEnMap = { 'noir': 'black', 'blanc': 'white', 'chene': 'oak', 'bouleau': 'birch' };
    var cEn = cEnMap[col];

    for (var i = 0; i < variants.length; i++) {
      var t = variants[i].t || '';
      if (t.indexOf(fmt) === -1) continue;
      if (isNone) {
        if (t.indexOf('sans') !== -1 || t.indexOf('no frame') !== -1 ||
            t.indexOf('unframed') !== -1 || t.indexOf('papier') !== -1 ||
            t.indexOf('paper') !== -1) {
          return variants[i].id;
        }
      } else {
        var hasColor = t.indexOf(cFr) !== -1 || (cEn && t.indexOf(cEn) !== -1) || t.indexOf(col) !== -1;
        var hasFrame = t.indexOf('cadre') !== -1 || t.indexOf('frame') !== -1;
        if (hasColor && hasFrame) return variants[i].id;
      }
    }
    return null;
  }

  /* Met a jour DIRECTEMENT l'input name="id" du form (contourne variant-selects
     qui peut echouer sur iPad Safari avec un <select> completement cache).
     Met aussi a jour l'URL ?variant=xxx pour coherence si partage. */
  function updateFormVariantId() {
    var vid = findVariantId();
    if (!vid) return;
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var input = forms[i].querySelector('input[name="id"]');
      if (input) {
        /* Force enabled + value via 2 mecanismes pour fiabilite iOS */
        input.disabled = false;
        input.removeAttribute('disabled');
        input.value = vid;
        input.setAttribute('value', vid);
      }
    }
    /* Met a jour l'URL sans rechargement (pour que le partage pointe sur le bon variant) */
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', vid);
      window.history.replaceState({}, '', url);
    } catch (e) {}
  }

  /* Met a jour l'image principale via DIRECT SWAP du src.
     Approche qui marche sur iOS car elle ne depend PAS de :
     - fetch() Shopify (echoue sur iOS)
     - Media gallery DOM swap (l'image du variant n'est pas dans le DOM)
     - variant-selects custom element et son pubsub

     Meme pattern que "Associez le" qui marche sur iPhone. */
  function updateFeaturedImage() {
    var vid = findVariantId();
    if (!vid) return;
    var v = null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].id === vid) { v = variants[i]; break; }
    }
    if (!v || !v.img) return;

    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    /* Cible le premier img visible (celui qui est affiche) */
    var activeItem = gallery.querySelector('.product__media-item.is-active')
                  || gallery.querySelector('[data-media-id].is-active')
                  || gallery.querySelector('.product__media-item')
                  || gallery.querySelector('[data-media-id]');
    if (!activeItem) return;

    var img = activeItem.querySelector('img');
    if (!img) return;

    var newSrc = v.img;
    var currentSrc = (img.getAttribute('src') || '').split('?')[0];
    var targetSrc = newSrc.split('?')[0];
    if (currentSrc === targetSrc) return; /* Deja la bonne image */

    /* ═══ ON REND SON IMAGE AU <li> QU'ON AVAIT BRICOLE (27/08) ═══
       Ecraser le src d'une diapo la CORROMPT pour de bon, et Dawn ne le
       rattrape jamais : product-info.js:254 `updateMedia()` reutilise les <li>
       deja dans la page — il les ajoute, retire et reordonne par
       data-media-id, mais ne relit PAS leur src dans la reponse du serveur.

       Une diapo bricolee ment donc de facon permanente : son data-media-id dit
       « A2 / Cadre noir », ses pixels disent « A4 / Sans cadre ». Le jour ou
       Shopify la reactive — parce que le visiteur revient sur ce cadre-la —
       elle affiche l'image d'une autre variante, et personne ne comprend
       pourquoi. C'est la panne que Max poursuit depuis ce matin.

       Le bricolage reste : il existe parce que la voie native echouait sur
       iPad Safari, et on ne retire pas un garde-fou sans l'avoir remplace. Mais
       il devient REVERSIBLE. Chaque diapo garde son src d'origine, et on la
       remet d'aplomb avant d'aller en bricoler une autre. A tout instant, une
       seule diapo est retouchee — celle qu'on regarde. */
    var bricolee = document.querySelector('[data-rv5-src-origine]');
    if (bricolee && bricolee !== img) {
      bricolee.setAttribute('src', bricolee.getAttribute('data-rv5-src-origine'));
      var srcsetOrigine = bricolee.getAttribute('data-rv5-srcset-origine');
      if (srcsetOrigine) bricolee.setAttribute('srcset', srcsetOrigine);
      bricolee.removeAttribute('data-rv5-src-origine');
      bricolee.removeAttribute('data-rv5-srcset-origine');
    }
    if (!img.hasAttribute('data-rv5-src-origine')) {
      img.setAttribute('data-rv5-src-origine', img.getAttribute('src') || '');
      if (img.getAttribute('srcset')) {
        img.setAttribute('data-rv5-srcset-origine', img.getAttribute('srcset'));
      }
    }

    /* CRUCIAL : supprimer srcset sinon Safari garde l'ancienne image via responsive */
    img.removeAttribute('srcset');
    img.removeAttribute('data-srcset');
    img.setAttribute('src', newSrc);

    /* Miroir dans la modale plein-ecran si elle existe */
    var mediaId = activeItem.getAttribute('data-media-id');
    if (mediaId) {
      var modalImg = document.querySelector('product-modal [data-media-id="' + mediaId + '"] img');
      if (modalImg) {
        modalImg.removeAttribute('srcset');
        modalImg.removeAttribute('data-srcset');
        modalImg.setAttribute('src', newSrc);
      }
    }
  }

  /* ── 1.3  Etat courant ───────────────────────────────────────── */

  var state = {
    format:    fmtList.dataset.initFormat || 'A4',
    withFrame: fmtList.dataset.initCadre === 'true',
    color:     fmtList.dataset.initColor || 'none'
  };

  /* ── 1.4  References DOM ─────────────────────────────────────── */

  var formatRows = fmtList.querySelectorAll('.rv5-format-row');
  var btnSans    = document.querySelector('.rv5-btn-sans');
  var btnAvec    = document.querySelector('.rv5-btn-avec');
  var colorLabel = document.getElementById('rv5-color-label');
  var swatches   = document.querySelectorAll('.rv5-color-swatch');
  var stockBox   = document.getElementById('rv5-bloc-stock');
  var stockText  = document.getElementById('rv5-stock-text');
  var stockFill  = document.getElementById('rv5-stock-fill');
  var stockNotice = document.getElementById('rv5-stock-notice');
  var atcPrice   = document.querySelector('.bisou-atc-price');

  /* Cree le <span> prix dans chaque format row s'il n'existe pas */
  formatRows.forEach(function (row) {
    if (!row.querySelector('.rv5-f-price')) {
      var span = document.createElement('span');
      span.className = 'rv5-f-price';
      row.appendChild(span);
    }
  });

  /* ── 1.5  Helpers ────────────────────────────────────────────── */

  /** Majuscule + accent pour les couleurs ("chene" -> "Chene") */
  function capitalizeColor(col) {
    if (col === 'chene') return 'Ch\u00eane';
    return col.charAt(0).toUpperCase() + col.slice(1);
  }

  /** Convertit un prix en centimes -> "45 EUR" (sans decimales) */
  function formatMoney(cents) {
    if (!cents) return '';
    return Math.round(cents / 100) + ' \u20ac';
  }

  /* ── 1.6  Synchronisation variant Shopify ──

     LA REGLE, DEPUIS LE 28/08 : on ne demande plus au serveur une variante en
     lui decrivant des MOTS, on la lui demande par ses VALEURS D'OPTION, telles
     que Shopify les ecrit lui-meme.

     Ce qui vivait ici cherchait « sans » ou « cadre » dans le texte des
     <option>. Quand aucun mot ne tombait juste, setRobustValue sortait en
     silence et laissait le <select> ou il etait — c'est-a-dire sur la finition
     PRECEDENTE, encadree. On envoyait alors au serveur un couple a moitie
     juste : le bon format, la mauvaise finition. Le serveur repondait
     honnetement « A4 / Cadre noir », et la fiche affichait 55 EUR sous une
     ligne a 35, avec l'image encadree, pendant que le panier — qui ne passe
     pas par la — restait juste. Les trois symptomes de Max, un seul geste
     manque.

     Maintenant : snippets/bisou-variant-ui.liquid depose pour chaque variante
     ses valeurs d'option (« o »), dans l'ordre des <select>. On les pose telles
     quelles. Aucun francais en dur, donc rien a re-traduire le jour ou
     Translate & Adapt traduira « Sans cadre » : les deux cotes viennent de la
     meme source et bougent ensemble.

     L'ancienne voie par mots reste, en repli, pour une fiche dont le JSON
     n'aurait pas les valeurs d'options. */

  /** L'ID de variante que le SERVEUR croit afficher : Dawn depose la variante
   *  retenue en JSON dans <variant-selects>. C'est notre seul moyen de savoir
   *  si on parle tous les deux du meme tirage. */
  function variantServeur() {
    var el = document.querySelector('variant-selects [data-selected-variant]');
    if (!el) return null;
    try {
      var v = JSON.parse(el.textContent);
      return v && v.id ? v.id : null;
    } catch (e) { return null; }
  }

  /** Pose une valeur d'option EXACTE sur un <select>. Rend false si l'option
   *  n'existe pas — auquel cas on ne dispatchera rien, plutot que d'envoyer au
   *  serveur une combinaison qu'on n'a pas voulue. */
  function poserValeurExacte(sel, valeur) {
    if (valeur === undefined || valeur === null) return false;
    var options = sel.querySelectorAll('option');
    for (var i = 0; i < options.length; i++) {
      var brut = options[i].value;
      var texte = (options[i].textContent || '').trim();
      if (brut === valeur || texte === valeur) {
        if (sel.value !== options[i].value) sel.value = options[i].value;
        return true;
      }
    }
    return false;
  }

  /** La variante que les <select> designent A CET INSTANT, deduite de leurs
   *  valeurs. C'est la verification avant envoi : si elle ne vaut pas celle
   *  qu'on visait, on se tait. */
  function variantDesSelects(selects) {
    var courant = [];
    for (var i = 0; i < selects.length; i++) courant.push(selects[i].value);
    for (var v = 0; v < variants.length; v++) {
      var o = variants[v].o;
      if (!o || o.length !== courant.length) continue;
      var pareil = true;
      for (var k = 0; k < o.length; k++) {
        if (o[k] !== courant[k]) { pareil = false; break; }
      }
      if (pareil) return variants[v].id;
    }
    return null;
  }

  function selectNativeVariant() {
    var vs = document.querySelector('variant-selects');
    if (!vs) return;
    var selects = vs.querySelectorAll('select');
    if (!selects.length) return;

    var fmt = state.format.toLowerCase();
    var isNone = !state.withFrame || state.color === 'none';
    var col = state.color;

    function matchFormat(txt) { return txt.indexOf(fmt) !== -1; }
    function matchFinition(txt) {
      if (isNone) {
        return txt.indexOf('sans') !== -1
            || txt.indexOf('no frame') !== -1
            || txt.indexOf('unframed') !== -1
            || txt.indexOf('papier') !== -1
            || txt.indexOf('paper') !== -1;
      }
      var cFr = col === 'chene' ? 'ch\u00eane' : col;
      var cEnMap = { 'noir': 'black', 'blanc': 'white', 'chene': 'oak', 'bouleau': 'birch' };
      var cEn = cEnMap[col];
      var hasColor = txt.indexOf(cFr) !== -1
                  || (cEn && txt.indexOf(cEn) !== -1)
                  || txt.indexOf(col) !== -1;
      var hasFrame = txt.indexOf('cadre') !== -1 || txt.indexOf('frame') !== -1;
      var sizeStr = (VARIANT_FRAME_SIZES[state.format] || '').toLowerCase();
      var hasSize = sizeStr && txt.indexOf(sizeStr) !== -1;
      return hasColor && (hasFrame || hasSize);
    }

    /* Pose la VALEUR, et rien d'autre. L'attribut `selected` est remis d'aplomb
       juste apres, pour TOUS les <select> a la fois — voir normaliserSelected.
       Cette fonction s'en melait, et c'est de la qu'est venue la panne du
       27/08 : quand la valeur voulue etait deja en place, elle sortait par
       `return false` sans jamais regarder ou se trouvait l'attribut. */
    function setRobustValue(sel, checkFn) {
      var options = sel.querySelectorAll('option');
      for (var i = 0; i < options.length; i++) {
        if (checkFn(options[i].textContent.toLowerCase())) {
          if (sel.value !== options[i].value) sel.value = options[i].value;
          return true;
        }
      }
      return false;
    }

    /* ═══ LA VOIE SURE : les valeurs d'option de la variante visee ═══ */
    var vid = findVariantId();
    var cible = null;
    for (var c = 0; c < variants.length; c++) {
      if (variants[c].id === vid) { cible = variants[c]; break; }
    }

    var posee = false;
    if (cible && cible.o && cible.o.length === selects.length) {
      posee = true;
      for (var s2 = 0; s2 < selects.length; s2++) {
        if (!poserValeurExacte(selects[s2], cible.o[s2])) { posee = false; break; }
      }
    }

    /* ═══ REPLI : l'ancienne reconnaissance par mots ═══
       Elle ne sert plus que si le JSON des variantes n'a pas les valeurs
       d'options — une fiche servie par un thema plus ancien, un cache. */
    if (!posee) {
      if (selects.length === 1) {
        setRobustValue(selects[0], function (txt) { return matchFormat(txt) && matchFinition(txt); });
      } else {
        for (var j = 0; j < selects.length; j++) {
          var name = (selects[j].getAttribute('name') || '').toLowerCase();
          if (name.indexOf('format') !== -1 || name.indexOf('taille') !== -1 || name.indexOf('size') !== -1) {
            setRobustValue(selects[j], matchFormat);
          } else {
            setRobustValue(selects[j], matchFinition);
          }
        }
      }
    }

    /* ═══ UN SEUL option[selected] PAR <select>, ET C'EST L'OPTION COURANTE ═══
       C'est la correction du 27/08, et elle explique a elle seule les trois
       symptomes que Max decrivait.

       Shopify ne lit PAS `select.value`. Il lit l'ATTRIBUT :

         get selectedOptionValues() {
           return Array.from(this.querySelectorAll('select option[selected], …'))
             .map(({ dataset }) => dataset.optionValueId);
         }                                          — assets/global.js:1119

       et product-info.js en fait `?option_values=id1,id2`. Deux <select>, donc
       deux identifiants — sauf si un <select> en porte deux. Il en part alors
       TROIS, le serveur tranche pour le premier qu'il sait resoudre, et rend un
       « A3 / Cadre noir » qu'on ne lui a jamais demande.

       D'ou venaient les doublons : setRobustValue sortait sans toucher a
       l'attribut quand la valeur etait deja bonne, et le garde qui vivait ici
       ne rattrapait que le cas ZERO — jamais le cas DEUX. Le
       `updateSelectionMetadata` de Dawn n'aide pas : son `.find()` ne retire
       que le PREMIER attribut trouve, donc il laisse le second en place.

       Les trois symptomes, un seul mecanisme :
         · l'image et le PRIX partent sur le cadre, parce qu'ils viennent du
           serveur ; le PANIER reste juste, parce qu'il vient de notre `state`
           via updateFormVariantId(). Max a vu exactement ca — « le prix de
           encadre, et au panier le sans cadre » ;
         · le bouton reste noir, parce que updateFrameButtons() lit `state`,
           qui n'a jamais bouge ;
         · et il se comporte en BASCULE parce que updateOptionValues() remplace
           tout le <variant-selects> par la reponse du serveur : au clic
           suivant la valeur differe enfin, l'attribut suit, et le tir se
           corrige — un coup juste, un coup faux.

       La regle est donc absolue : on efface TOUS les attributs du <select>,
       puis on le repose sur l'option courante. Un seul, toujours, et toujours
       d'accord avec la valeur. Le crash que l'ancien garde evitait — un
       `.find()` qui rend undefined quand il n'y a aucun attribut — reste
       evite : il y en a exactement un quand on sort d'ici. */
    function normaliserSelected(sel) {
      var marques = sel.querySelectorAll('option[selected]');
      for (var m = 0; m < marques.length; m++) marques[m].removeAttribute('selected');
      var courante = (sel.selectedOptions && sel.selectedOptions[0])
                  || sel.options[sel.selectedIndex]
                  || sel.options[0];
      if (courante) courante.setAttribute('selected', 'selected');
    }

    for (var k = 0; k < selects.length; k++) normaliserSelected(selects[k]);

    /* ═══ ON NE PARLE AU SERVEUR QUE SI LES <select> DISENT NOTRE VARIANTE ═══
       Un envoi a moitie juste ne donne pas « rien » : il donne le prix et
       l'image d'une AUTRE finition, ce qui est pire que l'immobilite. Quand la
       pose a echoue, on se tait — la fiche garde ses prix, ses dimensions et
       son panier, qui viennent de `state` et sont justes. */
    var poseeId = variantDesSelects(selects);
    if (vid && poseeId && poseeId !== vid) return;

    setTimeout(function () {
      selects[selects.length - 1].dispatchEvent(new Event('change', { bubbles: true }));
    }, 50);
  }

  /* ── 1.7  Fonctions de mise a jour UI ────────────────────────── */

  /** Barre de stock : texte, largeur, couleur, hint.
   *  Le reste vient de br-remaining, format par format. Quand il vaut null —
   *  edition ouverte, inventaire non suivi, format absent du catalogue — la
   *  barre entiere se masque : mieux vaut ne rien dire que dire « 10/10 » a
   *  tout le monde. */
  function updateStock() {
    if (!stockText || !stockFill) return;

    var hint = document.getElementById('rv5-stock-hint');
    var r = remaining[state.format];

    if (typeof r !== 'number') {
      if (stockBox) stockBox.hidden = true;
      stockText.textContent = '';
      if (hint) { hint.hidden = true; hint.textContent = ''; }
      return;
    }
    if (stockBox) stockBox.hidden = false;

    var pct = (r / QUOTA) * 100;
    var colorHex;

    if (r === 0) {
      stockText.textContent = (VCFG.stockSoldOut || '\u00c9puis\u00e9 en {format}').replace('{format}', state.format);
      pct = 100;
      colorHex = '#d94532';
    } else {
      stockText.textContent = (VCFG.stockRemaining || '{remaining}/{total} restants').replace('{remaining}', r).replace('{total}', QUOTA);
      if (r === QUOTA)  colorHex = '#c8c8c8';
      else if (r <= 3)  colorHex = '#d94532';
      else if (r <= 6)  colorHex = '#f5a623';
      else              colorHex = '#111111';
    }

    stockFill.style.cssText = 'width: ' + pct + '% !important; background-color: ' + colorHex + ' !important; height: 3px !important; transition: width 0.3s;';
    stockFill.classList.toggle('rv5-progress--full', pct >= 100 && r > 0);

    /* Le numero de tirage se deduit du QUOTA DU FORMAT — voir printNumber().
       Il ne s'affiche que si le reste est connu, ce qui est acquis ici. */
    if (hint) {
      hint.hidden = false;
      if (r === 0)             hint.textContent = VCFG.stockNoRestock  || 'Pas de restock';
      else if (r >= QUOTA - 3) hint.textContent = (VCFG.stockNextPrint || 'Vous obtiendrez le tirage n\u00b0{n}').replace('{n}', printNumber(r));
      else if (r <= 5)         hint.textContent = VCFG.stockNoRestock  || 'Pas de restock';
      else                     hint.textContent = VCFG.stockAlmostOut  || 'Bient\u00f4t \u00e9puis\u00e9';
    }
  }

  /** Panneau « edition limitee » : les memes compteurs que la fiche, depuis la
   *  meme source, et le meme silence quand elle ne sait pas. */
  function updateEditionPanel() {
    var r = remaining[state.format];
    var known = typeof r === 'number';
    var rem = document.querySelector('[data-rv5-edition-remaining]');
    var num = document.querySelector('[data-rv5-edition-number]');
    var DASH = '\u2014';
    if (rem) rem.textContent = known ? (r + '/' + QUOTA) : DASH;
    if (num) num.textContent = (known && r > 0) ? ('n\u00b0' + printNumber(r)) : DASH;
  }

  /** Label "SANS CADRE" / "Cadre Noir" sous les swatches */
  function updateColorLabel() {
    if (!colorLabel) return;
    colorLabel.textContent = (state.color === 'none')
      ? (VCFG.frameNoneUpper || 'SANS CADRE')
      : (LABELS[state.color] || VCFG.frameNoneUpper || 'SANS CADRE');
  }

  /** Classe .active sur le bon swatch */
  function updateSwatches() {
    swatches.forEach(function (s) {
      var col = s.dataset.col;
      s.classList.toggle('active', state.withFrame ? col === state.color : col === 'none');
    });
  }

  /** Classe .active sur Sans / Avec cadre */
  function updateFrameButtons() {
    if (!btnSans || !btnAvec) return;
    btnSans.classList.toggle('active', !state.withFrame);
    btnAvec.classList.toggle('active', state.withFrame);
  }

  /** Prix + dimensions (papier/cadre) + etat actif sur chaque ligne format */
  function updateFormatRows() {
    var isFramed = state.withFrame;
    formatRows.forEach(function (row) {
      var f = row.dataset.f;
      row.classList.toggle('active', f === state.format);
      var priceSpan = row.querySelector('.rv5-f-price');
      if (priceSpan) {
        priceSpan.textContent = formatMoney(isFramed ? prices[f].cadre : prices[f].sans);
      }
      /* Dimensions : cadre si avec cadre, papier sinon (lues depuis data-dim-frame / data-dim-paper) */
      var dimVal = row.querySelector('.rv5-f-dim-val');
      if (dimVal) {
        var txt = isFramed ? row.dataset.dimFrame : row.dataset.dimPaper;
        if (txt) dimVal.innerHTML = txt;
      }
    });
  }

  /** Prix affiche dans le bouton ATC */
  function updateAtcPrice() {
    if (!atcPrice) return;
    atcPrice.textContent = formatMoney(state.withFrame ? prices[state.format].cadre : prices[state.format].sans);
  }

  /** Livraison offerte : deux libelles, jamais les deux a la fois.
   *   au-dessus du seuil -> « Livraison offerte » + pastille verte
   *   en-dessous         -> « Livraison offerte des 150 EUR » en gris
   *  Le seuil vient de data-threshold, pose par snippets/bisou-variant-ui.liquid
   *  depuis le reglage de theme bisou_free_shipping_threshold : un seul endroit
   *  ou le changer, ici comme la-bas. */
  function updateShipping() {
    var currentPrice = state.withFrame ? prices[state.format].cadre : prices[state.format].sans;
    var spans = document.querySelectorAll('.rv5-shipping-aside');
    for (var i = 0; i < spans.length; i++) {
      var euros = parseInt(spans[i].getAttribute('data-threshold'), 10);
      if (isNaN(euros)) euros = 150;
      var isFree = currentPrice >= euros * 100;
      spans[i].classList.toggle('rv5-ship-free', isFree);
      var txt = spans[i].querySelector('.rv5-ship-txt');
      if (txt) {
        var label = isFree ? txt.getAttribute('data-ship-free') : txt.getAttribute('data-ship-from');
        if (label && txt.textContent !== label) txt.textContent = label;
      }
    }
  }

  /* ── 1.8  Etat global (pour la synchro associated products) ──── */

  window.__bisouState = state;

  /* ── 1.9  Master update ──────────────────────────────────────── */

  var updatingFromUI = false;

  function updateAll() {
    updatingFromUI = true;
    repriseRestante = 1;
    updateStock();
    updateColorLabel();
    updateSwatches();
    updateFrameButtons();
    updateFormatRows();
    updateAtcPrice();
    updateShipping();
    updateEditionPanel();
    /* FIX iPad Safari : force l'ID variant dans le form AVANT selectNativeVariant.
       Comme ca meme si variant-selects echoue, le cart recoit le bon variant. */
    updateFormVariantId();
    updateFeaturedImage();
    selectNativeVariant();
    document.dispatchEvent(new CustomEvent('bisou:variant-change', { detail: state }));
    setTimeout(function () { updatingFromUI = false; }, 200);
  }

  /* ── 1.10  Ecouteurs d'evenements ────────────────────────────── */

  /* Clic sur une ligne format (A2 / A3 / A4).
     Le premier geste du visiteur, quel qu'il soit, rend au tirage sa taille de
     catalogue : l'agrandissement de l'arrivee est une vitrine, pas une echelle.
     Un A4 RECHOISI est donc un petit A4. */
  formatRows.forEach(function (row) {
    row.addEventListener('click', function () {
      quitterZoomArrivee();
      formatRows.forEach(function (r) { r.classList.remove('active'); });
      row.classList.add('active');
      state.format = row.dataset.f;
      updateAll();
    });
  });

  /* Bouton "Sans cadre" */
  if (btnSans) {
    btnSans.addEventListener('click', function () {
      quitterZoomArrivee();
      state.withFrame = false;
      state.color = 'none';
      updateAll();
    });
  }

  /* Bouton "Avec cadre" */
  if (btnAvec) {
    btnAvec.addEventListener('click', function () {
      quitterZoomArrivee();
      state.withFrame = true;
      if (state.color === 'none') state.color = 'noir';
      updateAll();
    });
  }

  /* Clic sur un swatch couleur */
  swatches.forEach(function (sw) {
    sw.addEventListener('click', function () {
      quitterZoomArrivee();
      var col = sw.dataset.col;
      if (col === 'none') {
        state.withFrame = false;
        state.color = 'none';
      } else {
        state.withFrame = true;
        state.color = col;
      }
      updateAll();
    });
  });

  /* Bouton partager */
  var shareBtns = document.querySelectorAll('.rv5-btn-share');
  shareBtns.forEach(function (shareBtn) {
    /* Toast feedback visuel (uniquement pour le fallback clipboard) */
    /* -- 25/08 : ce toast etait la bande blanche a droite de la fiche mobile.
         Il mesure ~196px (white-space:nowrap), il etait centre sur un bouton
         de 28px colle au bord droit de la colonne, et il restait DANS LE FLUX
         (opacity:0 seulement). html/body portent overflow-x:visible !important
         (le garde-fou retire volontairement pour le position:sticky), donc
         ses ~44px de debord devenaient du scroll horizontal, en permanence.
         Deux verrous, aucun overflow:hidden :
           1. display:none tant qu'il est cache => zero boite, zero debord ;
           2. ancre a DROITE du bouton (right:0) => quand il s'affiche, il
              s'etale vers la gauche, jamais au-dela du bord de la colonne. */
    var shareToast = document.createElement('span');
    shareToast.style.cssText = 'display:none;position:absolute;bottom:calc(100% + 6px);right:0;left:auto;background:#111;color:#fff;font-size:10px;letter-spacing:.08em;padding:5px 10px;border-radius:4px;white-space:nowrap;pointer-events:none;opacity:0;transition:opacity .2s;z-index:999;';
    shareToast.textContent = VCFG.linkCopied || 'Lien copi\u00e9 !';
    shareBtn.style.position = 'relative';
    shareBtn.appendChild(shareToast);

    var shareToastTimer = null;
    function showShareToast() {
      if (shareToastTimer) clearTimeout(shareToastTimer);
      shareToast.style.display = 'block';
      /* force un reflow pour que la transition d'opacite parte de 0 */
      void shareToast.offsetWidth;
      shareToast.style.opacity = '1';
      shareToastTimer = setTimeout(function () {
        shareToast.style.opacity = '0';
        shareToastTimer = setTimeout(function () {
          shareToast.style.display = 'none';
          shareToastTimer = null;
        }, 250);
      }, 2000);
    }

    function copyFallback() {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(window.location.href).then(showShareToast).catch(legacyCopy);
      } else {
        legacyCopy();
      }
    }

    function legacyCopy() {
      var inp = document.createElement('input');
      inp.value = window.location.href;
      document.body.appendChild(inp);
      inp.select();
      try { document.execCommand('copy'); showShareToast(); } catch(e) {}
      document.body.removeChild(inp);
    }

    shareBtn.addEventListener('click', function () {
      if (navigator.share) {
        /* Ouvre le dialog natif — si l'utilisateur annule, on ne fait rien */
        navigator.share({ title: document.title, url: window.location.href }).catch(function () {});
      } else {
        /* Navigateur sans Web Share API : copier le lien + toast */
        copyFallback();
      }
    });
  });

  /* ── 1.11  Observer prix Shopify (synchro sens inverse) ──────── */
  /*    Quand Shopify met a jour le prix (via son propre systeme),  */
  /*    on repercute dans le bouton ATC sans decimales.             */

  if (atcPrice) {
    var priceContainer = document.getElementById('price-' + sectionId);
    if (priceContainer) {
      new MutationObserver(function () {
        if (updatingFromUI) return;
        /* ═══ LE PRIX DU SERVEUR NE S'AFFICHE QUE S'IL PARLE DE NOTRE TIRAGE ═══
           Le bouton annoncait « 55 EUR » sous une ligne A4 sans cadre a 35 : le
           serveur etait reste sur l'encadre, et on recopiait son prix sans
           jamais demander de quoi il parlait. En cas de desaccord, c'est NOTRE
           prix qui gagne — celui des lignes format, celui du panier. Un bouton
           qui ment sur le prix coute un client ; un bouton qui repete le prix
           de la ligne choisie n'en coute aucun. */
        var serveur = variantServeur();
        if (serveur && serveur !== findVariantId()) { updateAtcPrice(); return; }
        var priceEl = priceContainer.querySelector('.price-item--regular')
                   || priceContainer.querySelector('.price-item--sale');
        if (priceEl) {
          var digits = priceEl.textContent.trim().replace(/[^\d]/g, '');
          if (digits) atcPrice.textContent = Math.round(parseInt(digits, 10) / 100) + ' \u20ac';
        }
      }).observe(priceContainer, { childList: true, subtree: true, characterData: true });
    }
  }

  /* ── 1.11.a  RATTRAPAGE : le serveur a rendu une autre variante ─────
        Il reste des chemins ou le serveur repond a cote : deux clics coup sur
        coup, une reponse en retard, un <select> remplace en pleine course. On
        ne se contente pas de ne plus mentir sur le prix — on REDEMANDE, une
        fois, la variante voulue. L'image et le prix se remettent d'aplomb sans
        que le visiteur ait a recliquer.

        UNE SEULE reprise par geste du visiteur (remise a 1 dans updateAll).
        Sans ce compteur, une variante que le serveur ne sait pas resoudre nous
        ferait tourner en boucle : chaque reponse declencherait une demande. */
  var repriseRestante = 0;
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        if (repriseRestante <= 0) return;
        var voulu = findVariantId();
        var servi = variantServeur();
        if (!voulu || !servi || servi === voulu) return;
        repriseRestante--;
        selectNativeVariant();
      });
    }
  } catch (e) {}

  /* ── 1.11.b  SAFETY NET : hook submit en phase capture ──────────
     Re-force l'ID variant juste avant que ProductForm.onSubmitHandler
     ne construise son FormData. Meme si quelque chose reset la valeur
     entre updateAll() et le clic ATC, on la remet au dernier moment.
     Capture=true garantit qu'on s'execute AVANT le listener de Shopify. */
  var allForms = document.querySelectorAll('form[action*="/cart/add"]');
  for (var fIdx = 0; fIdx < allForms.length; fIdx++) {
    allForms[fIdx].addEventListener('submit', function () {
      var vid = findVariantId();
      if (!vid) return;
      var input = this.querySelector('input[name="id"]');
      if (input) {
        input.disabled = false;
        input.removeAttribute('disabled');
        input.value = vid;
        input.setAttribute('value', vid);
      }
      /* Desactive temporairement les <select> caches pour qu'ils ne polluent
         pas le FormData. Shopify prendra juste l'input[name=id]. */
      var vs = document.querySelector('variant-selects');
      if (vs) {
        var sels = vs.querySelectorAll('select');
        for (var s = 0; s < sels.length; s++) {
          sels[s].disabled = true;
        }
        /* Re-active apres un tick pour ne pas casser d'autres choses */
        setTimeout(function () {
          for (var ss = 0; ss < sels.length; ss++) {
            sels[ss].disabled = false;
          }
        }, 100);
      }
    }, true);
  }

  /* ── 1.11.c  COLLISION DE NUMERO DE TIRAGE ─────────────────────
        Le numero est attribue A L'ACHAT, pas reserve au panier (Max, 26/08).
        Un acheteur peut donc lire « vous obtiendrez le n°4 », laisser l'article
        dans son panier, et voir le n°4 partir chez quelqu'un d'autre. Sa regle :
        on le lui DIT.

          · il reste encore des exemplaires -> « le n°4 vient d'etre achete,
            vous aurez le n°5 » ;
          · c'etait le dernier du quota     -> il n'y a plus de produit dans ce
            format, et on le dit aussi.

        Comment on l'apprend : on relit la SECTION produit (Section Rendering
        API), qui re-execute br-remaining cote serveur. Aucune source parallele,
        aucun calcul en double — exactement le nombre qu'un rechargement de la
        page afficherait.

        Quand on regarde : a l'ajout au panier, au retour sur l'onglet, et une
        fois par minute tant que la page est visible ET qu'un format de ce
        produit est dans le panier. Une fiche qu'on regarde sans rien mettre au
        panier ne declenche aucune requete. */
  (function watchPrintNumber() {
    if (!stockNotice || !variants.length) return;

    var productInfo = document.querySelector('product-info');
    var productUrl = (productInfo && productInfo.dataset.url) || '';
    if (!productUrl || !sectionId) return;

    var FORMATS = ['A2', 'A3', 'A4'];

    /* Le format d'un variant, lu dans la table deja injectee par Liquid. */
    var formatById = {};
    variants.forEach(function (v) {
      var t = String(v.t || '');
      var f = t.indexOf('a2') !== -1 ? 'A2' : t.indexOf('a3') !== -1 ? 'A3' : t.indexOf('a4') !== -1 ? 'A4' : null;
      if (f) formatById[v.id] = f;
    });

    /* Ce qui a ete ANNONCE a l'acheteur quand l'article est entre dans son
       panier : le reste d'alors, donc le numero d'alors. Garde par onglet — le
       panier vit deja cote serveur, on ne duplique pas son etat. */
    var STORE_KEY = 'br:print-claim:' + productUrl;
    var claims = {};
    try { claims = JSON.parse(sessionStorage.getItem(STORE_KEY) || '{}') || {}; } catch (e) { claims = {}; }
    function saveClaims() {
      try { sessionStorage.setItem(STORE_KEY, JSON.stringify(claims)); } catch (e) {}
    }

    function showNotice(msg) {
      stockNotice.textContent = msg;
      stockNotice.hidden = false;
      if (stockBox) stockBox.hidden = false;
    }

    /* Les formats de CE produit presents dans le panier. */
    function cartFormats() {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (cart) {
          var out = {};
          if (!cart || !cart.items) return out;
          cart.items.forEach(function (item) {
            var f = formatById[item.id];
            if (f) out[f] = true;
          });
          return out;
        })
        .catch(function () { return {}; });
    }

    /* Note le numero annonce pour chaque format present au panier, et oublie
       les formats qui en sont sortis. */
    function noteClaims() {
      return cartFormats().then(function (inCart) {
        var changed = false;
        FORMATS.forEach(function (f) {
          if (inCart[f]) {
            if (claims[f] === undefined && typeof remaining[f] === 'number') {
              claims[f] = remaining[f];
              changed = true;
            }
          } else if (claims[f] !== undefined) {
            delete claims[f];
            changed = true;
          }
        });
        if (changed) saveClaims();
        return inCart;
      });
    }

    /* Relit la section et rend les trois restes frais, ou null si la lecture
       echoue — auquel cas on ne dit rien plutot que d'inventer. */
    function freshRemaining() {
      var url = productUrl + (productUrl.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sectionId);
      return fetch(url, { headers: { 'Accept': 'text/html' } })
        .then(function (res) { return res.ok ? res.text() : null; })
        .then(function (html) {
          if (!html) return null;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var list = doc.getElementById('rv5-bloc-fmt');
          if (!list) return null;
          return {
            A2: readRemaining(list.dataset.remainingA2),
            A3: readRemaining(list.dataset.remainingA3),
            A4: readRemaining(list.dataset.remainingA4)
          };
        })
        .catch(function () { return null; });
    }

    function check() {
      if (document.visibilityState === 'hidden') return;
      noteClaims().then(function () {
        var watched = Object.keys(claims);
        if (!watched.length) return;
        return freshRemaining().then(function (fresh) {
          if (!fresh) return;
          var message = null;
          watched.forEach(function (f) {
            var before = claims[f];
            var now = fresh[f];
            if (typeof now !== 'number' || typeof before !== 'number' || now >= before) return;

            /* Le numero que l'acheteur avait lu, et celui qu'il aura. */
            var lost = printNumber(before);
            if (now === 0) {
              message = (VCFG.numberGone || 'Le n°{lost} vient d’être acheté. C’était le dernier {format} de cette édition.')
                .replace('{lost}', lost).replace('{format}', f);
            } else {
              message = (VCFG.numberTaken || 'Le n°{lost} vient d’être acheté — vous aurez le n°{next}.')
                .replace('{lost}', lost).replace('{next}', printNumber(now));
            }
            claims[f] = now;
          });

          /* Les compteurs de la fiche suivent le meme rafraichissement : la
             barre, le panneau edition et le cartel disent la meme chose. */
          remaining.A2 = fresh.A2;
          remaining.A3 = fresh.A3;
          remaining.A4 = fresh.A4;
          fmtList.dataset.remainingA2 = fresh.A2 === null ? '' : fresh.A2;
          fmtList.dataset.remainingA3 = fresh.A3 === null ? '' : fresh.A3;
          fmtList.dataset.remainingA4 = fresh.A4 === null ? '' : fresh.A4;
          updateStock();
          updateEditionPanel();
          document.dispatchEvent(new CustomEvent('bisou:variant-change', { detail: state }));

          /* APRES le rafraichissement, sinon updateStock() rabattrait le
             conteneur sur le format courant et masquerait le message. */
          if (message) { showNotice(message); saveClaims(); }
        });
      });
    }

    /* L'ajout au panier note le numero annonce sans relire la boutique : a cet
       instant precis, ce que la page affiche EST ce qui vient d'etre promis. */
    /* PUB_SUB_EVENTS est un `const` de assets/constants.js : il vit dans la
       portee lexicale globale, PAS sur window. On le lit par son nom nu, sous
       typeof, sinon la souscription serait silencieusement sautee. */
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () { noteClaims(); });
      }
    } catch (e) {}

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') check();
    });
    /* Trois minutes : la relecture de section n'est pas gratuite, et le moment
       qui compte vraiment — le retour sur l'onglet avant de payer — est deja
       couvert par visibilitychange. */
    setInterval(check, 180000);
    noteClaims();
  })();

  /* ── 1.12  Debug overlay (activer avec ?bisou-debug=1) ──────────── */
  var debugBox = null;
  if (window.location.search.indexOf('bisou-debug=1') !== -1) {
    debugBox = document.createElement('div');
    debugBox.style.cssText = 'position:fixed;bottom:0;left:0;right:0;background:#000;color:#0f0;font:10px monospace;padding:8px;z-index:999999;max-height:40vh;overflow:auto;white-space:pre-wrap;line-height:1.4;border-top:2px solid #0f0;';
    document.body.appendChild(debugBox);
  }

  function debugDump(label) {
    if (!debugBox) return;
    var lines = [];
    lines.push('── ' + label + ' ──');
    lines.push('state: ' + JSON.stringify(state));
    lines.push('variants loaded: ' + variants.length);
    var vid = findVariantId();
    lines.push('findVariantId(): ' + vid);
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    lines.push('forms found: ' + forms.length);
    for (var i = 0; i < forms.length; i++) {
      var inp = forms[i].querySelector('input[name="id"]');
      lines.push('  form[' + i + '] input[name=id] = ' + (inp ? inp.value : 'NOT FOUND') + (inp && inp.disabled ? ' (disabled)' : ''));
    }
    var vs = document.querySelector('variant-selects');
    if (vs) {
      var ss = vs.querySelectorAll('select');
      lines.push('variant-selects exists, selects: ' + ss.length);
      for (var j = 0; j < ss.length; j++) {
        lines.push('  select[' + j + '] name=' + ss[j].name + ' value=' + ss[j].value);
        /* On les compte TOUS. Un seul est correct ; deux, c'est la panne du
           27/08 qui revient, et le serveur rendra une variante qu'on n'a pas
           demandee. Afficher le premier seulement l'aurait cachee. */
        var marques = ss[j].querySelectorAll('option[selected]');
        var noms = [];
        for (var m = 0; m < marques.length; m++) noms.push(marques[m].textContent);
        lines.push('    option[selected] x' + marques.length + ' = ' + (noms.join(' + ') || 'NONE')
                 + (marques.length === 1 ? '' : '   <<< ANORMAL'));
      }
    } else {
      lines.push('variant-selects: NOT FOUND');
    }
    /* Prix dictionary + ATC display */
    lines.push('prices dict:');
    lines.push('  A4 cadre=' + prices.A4.cadre + ' sans=' + prices.A4.sans);
    lines.push('  A3 cadre=' + prices.A3.cadre + ' sans=' + prices.A3.sans);
    lines.push('  A2 cadre=' + prices.A2.cadre + ' sans=' + prices.A2.sans);
    var expectedPrice = state.withFrame ? prices[state.format].cadre : prices[state.format].sans;
    lines.push('expected ATC: ' + Math.round(expectedPrice / 100) + ' \u20ac');
    var atcEl = document.querySelector('.bisou-atc-price');
    lines.push('actual ATC text: ' + (atcEl ? atcEl.textContent : 'NOT FOUND'));
    /* Variant image info (direct swap) */
    var v = null;
    for (var m = 0; m < variants.length; m++) {
      if (variants[m].id === vid) { v = variants[m]; break; }
    }
    lines.push('variant.img URL: ' + (v && v.img ? v.img.substring(0, 80) + '...' : 'MISSING'));
    var gallery = document.querySelector('media-gallery');
    if (gallery) {
      var firstImg = gallery.querySelector('img');
      if (firstImg) {
        var curSrc = firstImg.getAttribute('src') || '';
        lines.push('gallery img src: ' + curSrc.substring(0, 80) + '...');
        lines.push('has srcset: ' + (firstImg.hasAttribute('srcset') ? 'YES (should be cleared)' : 'NO (good)'));
        if (v && v.img) {
          var match = curSrc.split('?')[0] === v.img.split('?')[0];
          lines.push('SRC MATCHES variant: ' + (match ? 'YES ✓' : 'NO ✗ → swap needed'));
        }
      } else {
        lines.push('gallery img: NOT FOUND');
      }
    }
    debugBox.textContent = lines.join('\n');
  }

  /* Hook debugDump apres chaque updateAll */
  var originalUpdateAll = updateAll;
  updateAll = function () {
    originalUpdateAll();
    debugDump('after updateAll');
  };

  /* ── 1.13  Initialisation ────────────────────────────────────── */
  /*    Dans l'editeur Shopify : pas de selectNativeVariant         */
  /*    (evite un crash quand variant-selects n'est pas pret).     */

  /* ══════════════════════════════════════════════════════════════
     L'ARRIVEE SUR LA FICHE — deux interrupteurs, et rien d'autre
     ══════════════════════════════════════════════════════════════
     Max, 27/08 : on ouvre sur « A4 sans cadre », agrandi, pour que le premier
     prix affiche 35 € au lieu de 175. Une edition limitee a 35 € n'est pas la
     meme barriere mentale qu'a 175, et le tirage doit quand meme remplir
     l'ecran — sinon c'est le petit format qui a l'air petit.

     Les reglages sont des CONSTANTES, pas du code efface. C'est un test :
     si le A4 encadre convertit mieux, on remet FRAME_PARAM_ACTIF a true et on
     passe ARRIVEE_A4_SANS a false. Deux lignes, aucune archeologie.

     Max, 28/08 : l'agrandissement d'arrivee est abandonne. On arrive sur
     A4 sans cadre a sa taille de catalogue — la vraie, celle qu'il garde
     quand on le rechoisit. ZOOM_ARRIVEE_ACTIF le rallumerait. */
  var ARRIVEE_A4_SANS  = true;   /* on ouvre sur A4 / Sans cadre (ordinateur) */
  var ARRIVEE_MOBILE_CADRE = true; /* sur mobile, le meme A4 mais ENCADRE (Max, 28/08) */
  var ZOOM_ARRIVEE_ACTIF = false; /* agrandissement d'arrivee : abandonne le 28/08 */
  var FRAME_PARAM_ACTIF = false; /* ?frame= des cartes de collection : debranche */

  /* ── Couleur de cadre transmise par la carte cliquée (?frame=) : on ouvre la
        fiche sur la même finition que celle vue dans la grille d'origine.
        Debranche le 27/08 — il gagnait contre l'arrivee A4, et c'est
        justement l'arrivee A4 qu'on veut mesurer. Le code reste entier. ── */
  (function applyIncomingFrame() {
    if (!FRAME_PARAM_ACTIF) return;
    var col;
    try { col = new URLSearchParams(window.location.search).get('frame'); } catch (e) { return; }
    if (!col) return;
    col = col.toLowerCase();
    var alias = { black: 'noir', white: 'blanc', oak: 'chene', 'chêne': 'chene', birch: 'bouleau', sans: 'none', paper: 'none', papier: 'none' };
    col = alias[col] || col;
    if (col === 'none') { state.withFrame = false; state.color = 'none'; return; }
    if (LABELS[col]) { state.withFrame = true; state.color = col; }
  })();

  /* ── L'ARRIVEE PAR DEFAUT ──
     Un lien PARTAGE porte toujours ?variant= : quelqu'un a choisi ce tirage-la
     et l'a envoye. On ne le lui reecrit pas. Le reste — recherche, menu, carte
     de collection, lien nu — arrive sur A4 sans cadre.

     Attention : updateFormVariantId() ecrit ?variant= dans l'URL a chaque
     changement. La lecture se fait donc ICI, avant le premier updateAll(), et
     une seule fois. */
  var zoomArrivee = false;
  (function arriveeParDefaut() {
    if (!ARRIVEE_A4_SANS) return;
    var partage = false;
    try { partage = !!new URLSearchParams(window.location.search).get('variant'); } catch (e) {}
    if (partage) return;
    state.format    = 'A4';
    state.withFrame = false;
    state.color     = 'none';
    zoomArrivee     = ZOOM_ARRIVEE_ACTIF;

    /* Sur mobile, le A4 arrive ENCADRE : sur un petit ecran, un tirage nu
       fait moins envie qu'un tirage au mur. La couleur est celle que le
       Liquid a choisie — le metachamp br_featured_finish, noir par defaut —
       lue dans data-init-color, pour que la fiche et la carte de collection
       disent le meme cadre. 899 px : le seuil mobile de tout le theme. */
    if (ARRIVEE_MOBILE_CADRE) {
      var mobile = false;
      try { mobile = window.matchMedia('(max-width: 899px)').matches; } catch (e) {}
      if (mobile) {
        var couleur = fmtList.dataset.initColor || 'noir';
        if (couleur === 'none' || !LABELS[couleur]) couleur = 'noir';
        state.withFrame = true;
        state.color     = couleur;
      }
    }
  })();

  /* ── L'AGRANDISSEMENT DE L'ARRIVEE ──
     150 %, mesure sur les rendus : le tirage occupe 52 x 59 % du canevas en
     A4 sans cadre, contre 85 x 96 % en A2. Il faudrait 163 % pour egaler le
     A2 ; a 150 % le A4 reste un peu plus petit, ce que Max demande — « pas
     loin d'etre aussi grand ». Verifie a 390, 1000 et 1745 px : le tirage
     agrandi tient dans la zone, seul le canevas transparent deborde.

     L'agrandissement ne survit a AUCUN choix. Des que le visiteur touche un
     format, un bouton de cadre ou une pastille, il a pris la main : les
     tailles redeviennent celles du catalogue, et un A4 rechoisi est un petit
     A4. C'est le sens de la demande — l'agrandissement est une vitrine, pas
     une echelle.

     La classe d'animation arrive DEUX TRAMES apres celle du zoom : sinon la
     page s'ouvrirait sur un travelling avant, alors qu'on veut arriver DEJA
     agrandi. La transition ne sert donc qu'a la sortie. */
  function mediaWrapper() { return document.querySelector('.product__media-wrapper'); }

  function poserZoomArrivee() {
    if (!zoomArrivee) return;
    var gr = mediaWrapper();
    if (!gr) return;
    gr.classList.add('rv5-boot-zoom');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { gr.classList.add('rv5-boot-zoom--anim'); });
    });
  }

  function quitterZoomArrivee() {
    if (!zoomArrivee) return;
    zoomArrivee = false;
    var gr = mediaWrapper();
    if (gr) gr.classList.remove('rv5-boot-zoom');
  }

  if (!window.Shopify || !Shopify.designMode) {
    updateAll();
    poserZoomArrivee();
  } else {
    updateStock();
    updateColorLabel();
    updateSwatches();
    updateFrameButtons();
    updateFormatRows();
    updateAtcPrice();
    updateShipping();
    updateEditionPanel();
    updateFormVariantId();
  }

})();


/* ================================================================
   2. S2 SCROLL ACCELERE
   La section "Associe le" remonte 1.3x plus vite que le scroll
   normal pour un effet reveal. Desactive sur mobile (< 900 px).
   ================================================================ */
(function () {
  'use strict';
  /* Effet de scroll accéléré DÉSACTIVÉ : la section suit le flux normal.
     ⚠ NE PAS poser de transform inline ici : sur mobile le CSS full-bleed
     de .rv5-associated repose sur translateX(-50%) — un transform:none
     inline décalait tout le bloc « Associez le » vers la droite. */
})();


/* ================================================================
   3. ASSOCIATED PRODUCTS (recommandations)
   Fetch des produits recommandes par Shopify, filtrage par
   orientation (V-/H- dans le titre), affichage de 2 cards max
   et mise a jour des images quand le variant principal change.
   ================================================================ */
(function () {
  'use strict';

  var container = document.getElementById('rv5-bloc-associated');
  if (!container) return;

  /* Pont i18n : deux aria-labels, posés par snippets/bisou-variant-ui.liquid.
     Repli français conservé si le pont manque. */
  var ASSOC_I18N = {};
  try { ASSOC_I18N = JSON.parse((document.getElementById('rv5-assoc-i18n') || {}).textContent || '{}'); } catch (e) {}
  function assocLabel(key, fallback) {
    var v = ASSOC_I18N[key];
    return (typeof v === 'string' && v) ? v : fallback;
  }

  var productId   = container.dataset.productId;
  var orientation = container.dataset.orientation;
  var grid        = container.querySelector('.rv5-associated-grid');
  if (!productId || !grid) return;

  var picks = [];

  /* ── Trouver l'image variant qui correspond a l'etat principal (bilingual) ── */
  function findVariantImage(product, st) {
    if (!product.variants || !st) return null;

    var fmt = st.format.toLowerCase();
    var isNone = !st.withFrame || st.color === 'none';

    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      var vTitle = (v.title || '').toLowerCase();

      if (vTitle.indexOf(fmt) === -1) continue;

      if (isNone) {
        var isNoFrame = vTitle.indexOf('sans') !== -1
                     || vTitle.indexOf('no frame') !== -1
                     || vTitle.indexOf('unframed') !== -1
                     || vTitle.indexOf('papier') !== -1
                     || vTitle.indexOf('paper') !== -1;
        if (isNoFrame && v.featured_image) return v.featured_image.src;
      } else {
        var col = st.color;
        var cFr = col === 'chene' ? 'ch\u00eane' : col;
        var cEnMap = { 'noir': 'black', 'blanc': 'white', 'chene': 'oak', 'bouleau': 'birch' };
        var cEn = cEnMap[col];
        var hasColor = vTitle.indexOf(cFr) !== -1
                    || (cEn && vTitle.indexOf(cEn) !== -1)
                    || vTitle.indexOf(col) !== -1;
        var hasFrame = vTitle.indexOf('cadre') !== -1 || vTitle.indexOf('frame') !== -1;
        if (hasColor && hasFrame && v.featured_image) return v.featured_image.src;
      }
    }
    return null;
  }

  /* Table « id du produit → artiste », posee par snippets/br-assoc-artists.liquid.
     Le JSON de /recommendations/products.json ne porte ni metachamp ni
     metaobjet, et son `vendor` vaut « Bisou Rivage » sur les 36 tirages : sans
     cette table, la carte n'aurait ni nom d'artiste ni photo, et « Associez-le »
     ne montrerait pas la meme composition que les grilles. */
  var ASSOC_ARTISTS = {};
  try { ASSOC_ARTISTS = JSON.parse((document.getElementById('rv5-assoc-artists') || {}).textContent || '{}'); } catch (e) {}

  function assocEsc(v) {
    var d = document.createElement('div');
    d.textContent = String(v == null ? '' : v);
    return d.innerHTML.replace(/"/g, '&quot;');
  }

  /* ── Generer le HTML des cards ── */
  function renderCards(st) {
    var html = '';
    picks.forEach(function (p, idx) {
      var imgUrl = findVariantImage(p, st);
      if (!imgUrl) {
        imgUrl = (typeof p.featured_image === 'string')
          ? p.featured_image
          : (p.featured_image && p.featured_image.src) || '';
      }
      if (imgUrl) imgUrl += (imgUrl.indexOf('?') === -1 ? '?' : '&') + 'width=400';

      /* Le prix vient du serveur, pas d'ici. Voir snippets/br-assoc-artists :
         ce JS ignore le format monetaire de la boutique, la devise du marche
         visite, et le fait qu'un tirage vendu en trois formats se presente
         « a partir de ». Liquid sait les trois, et les grilles lisent deja sa
         reponse. Le calcul local ne reste qu'en secours, pour un produit
         absent de la table. */
      var fiche  = ASSOC_ARTISTS[String(p.id)] || null;
      var price  = (fiche && fiche.pr)
                 ? fiche.pr
                 : ((p.price / 100).toFixed(2).replace('.', ',') + ' \u20AC');
      var title  = p.title || '';

      /* L'artiste : le nom, puis sa pastille ronde a DROITE. Metaobjet sans
         photo → l'initiale sur fond gris, jamais un trou dans la ligne. */
      var artist = fiche;
      var artistHtml = '';
      if (artist && artist.n) {
        var initial = String(artist.n).replace('@', '').charAt(0).toUpperCase();
        artistHtml = '<div class="rv5-assoc-card-vendor">'
                   +   '<span class="rv5-assoc-card-vendor-name">' + assocEsc(artist.n) + '</span>'
                   +   '<span class="rv5-assoc-card-pastille" aria-hidden="true">'
                   +     (artist.p
                          ? '<img src="' + assocEsc(artist.p) + '" alt="" loading="lazy" width="72" height="72">'
                          : '<span class="rv5-assoc-card-initial">' + assocEsc(initial) + '</span>')
                   +   '</span>'
                   + '</div>';
      }

      var assocFrame = (!st.withFrame || st.color === 'none') ? 'none' : st.color;
      /* `title` vient du titre du produit, donc du catalogue, donc d'un champ
         que quelqu'un tape. Il partait brut dans le HTML de la carte : une
         apostrophe typographique passait, un chevron non. `assocEsc` est deja
         la pour l'artiste, elle sert aussi au titre — dans le corps de la
         carte comme dans l'`alt` de l'image, ou `.replace` ne couvrait que le
         guillemet droit. L'adresse et l'image sortent de la meme reponse : on
         les echappe du meme geste. */
      /* ── « ASSOCIEZ-LE » NE GARDE QUE LES TITRES (Max, 26/08) ──
         La vignette portait trois lignes — titre, artiste, prix — sous une
         image de 5/6,5. Elle n'en garde qu'une. Le bloc propose un
         rapprochement d'images ; le nom et le prix se lisent sur la fiche,
         a un clic.

         `artistHtml` et `price` restent calcules juste au-dessus, et la table
         `ASSOC_ARTISTS` reste posee par snippets/br-assoc-artists.liquid :
         rien n'est demonte, seules les deux lignes ne sont plus ecrites dans
         la carte. Les remettre, c'est rajouter les deux `+` ci-dessous. */
      html += '<a href="' + assocEsc(p.url) + '" class="rv5-assoc-card" data-assoc-idx="' + idx + '" data-bisou-frame="' + assocEsc(assocFrame) + '">'
            +   '<div class="rv5-assoc-card-img">'
            +     '<img src="' + assocEsc(imgUrl) + '" alt="' + assocEsc(title) + '" loading="lazy">'
            +   '</div>'
            +   '<div class="rv5-assoc-card-info">'
            +     '<div class="rv5-assoc-card-title">' + assocEsc(title) + '</div>'
            +   '</div>'
            + '</a>';
    });
    grid.innerHTML = html;
  }

  /* ── Carrousel : wrapper + flèches desktop (le swipe mobile est natif) ── */
  function setupAssocCarousel() {
    if (container.dataset.assocCarousel) return;
    container.dataset.assocCarousel = '1';

    var wrap = document.createElement('div');
    wrap.className = 'rv5-assoc-wrap';
    grid.parentNode.insertBefore(wrap, grid);
    wrap.appendChild(grid);

    function arrow(dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'rv5-assoc-arrow rv5-assoc-arrow--' + (dir < 0 ? 'prev' : 'next');
      b.setAttribute('aria-label', dir < 0
        ? assocLabel('assoc_prev', 'Propositions précédentes')
        : assocLabel('assoc_next', 'Propositions suivantes'));
      b.innerHTML = dir < 0
        ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>'
        : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>';
      /* LE PAS D'UNE FLECHE EST CELUI D'UNE CARTE, PAS LA MOITIE DE LA PISTE.

         Il valait `Math.round(grid.clientWidth / 2)`. Ce n'est pas la meme
         chose : la carte fait `calc(50% - 1px)` et la gouttiere 2 px, donc le
         pas reel vaut `clientWidth / 2 + 1`. Mesure au navigateur sur la
         colonne de 600 px : pas reel 301 px, pas envoye 300 px. Un pixel de
         moins a chaque clic, six pixels apres six clics — les vignettes
         finissent a cote de leur axe, et c'est ce que Max voit.

         On mesure donc le pas sur le DOM, entre deux cartes voisines, au lieu
         de le deduire d'une formule qui ignore la gouttiere. Repli sur
         l'ancien calcul s'il n'y a qu'une carte.

         ET ON ATTERRIT SUR UN CRAN. La cible est arrondie a un multiple du pas
         puis bornee a [0, max]. Releve au navigateur, huit cartes, six clics :
         ancien 300 / 600 / 900 / 1200 / 1500 / 1800, nouveau 301 / 602 / 903 /
         1204 / 1505 / 1806. La colonne des crans est celle de droite.

         Le bout de la course, lui, se regle en CSS et pas ici : la derniere
         carte s'aligne par sa fin (`scroll-snap-align: end`), sinon le cran de
         la derniere carte tombe 301 px APRES le bout de la piste et le
         navigateur, en `mandatory`, refuse de s'y arreter. Voir le cartouche N3
         de assets/bisou-variant-ui.css. */
      b.addEventListener('click', function () {
        var cards = grid.querySelectorAll('.rv5-assoc-card');
        var pas = grid.clientWidth / 2;
        if (cards.length > 1) {
          var ecart = cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left;
          if (ecart > 1) pas = ecart;
        }
        var max = grid.scrollWidth - grid.clientWidth;
        var cible = grid.scrollLeft + dir * pas;
        cible = Math.round(cible / pas) * pas;
        if (cible < 0) cible = 0;
        if (cible > max) cible = max;
        grid.scrollTo({ left: cible, behavior: 'smooth' });
      });
      wrap.appendChild(b);
      return b;
    }
    var prev = arrow(-1);
    var next = arrow(1);

    function refreshArrows() {
      var max = grid.scrollWidth - grid.clientWidth;
      prev.hidden = grid.scrollLeft <= 1;
      next.hidden = grid.scrollLeft >= max - 1;
    }
    grid.addEventListener('scroll', refreshArrows, { passive: true });
    window.addEventListener('resize', refreshArrows);
    /* Départ TOUJOURS sur la première carte (mobile : évite tout désaxage) */
    grid.scrollLeft = 0;
    setTimeout(function () { grid.scrollLeft = 0; refreshArrows(); }, 0);
    /* renderCards remplace l'innerHTML du grid à chaque changement de variante :
       le wrapper et les flèches vivent en dehors, rien à refaire. */
  }

  /* ── Fetch & affichage ── */
  var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  fetch(rootUrl + 'recommendations/products.json?product_id=' + productId + '&limit=10')
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var products = data.products || [];
      if (!products.length) { container.style.display = 'none'; return; }

      /* Orientation d'un produit recommande : la balise orientation-* que l'App
         pose sur les fiches v2. Repli sur le prefixe H-/V- du titre pour les
         tirages encore en v1, dont le titre EST la reference. Ce repli tombera
         quand les 35 seront bascules. */
      var wantTag = orientation === 'horizontal' ? 'orientation-horizontal' : 'orientation-vertical';
      var prefix  = orientation === 'horizontal' ? 'H-' : 'V-';
      var filtered = products.filter(function (p) {
        var tags = p.tags || [];
        if (tags.indexOf('orientation-horizontal') !== -1 || tags.indexOf('orientation-vertical') !== -1) {
          return tags.indexOf(wantTag) !== -1;
        }
        return p.title && p.title.toUpperCase().indexOf(prefix) === 0;
      });

      /* Carrousel : jusqu'à 8 propositions (orientation assortie en premier),
         2 visibles à la fois — flèches desktop, swipe mobile. */
      var rest = products.filter(function (p) { return filtered.indexOf(p) === -1; });
      picks = filtered.concat(rest).slice(0, 8);
      if (!picks.length) { container.style.display = 'none'; return; }

      renderCards(window.__bisouState);
      setupAssocCarousel();
    })
    .catch(function () {
      container.style.display = 'none';
    });

  /* ── Ecouter les changements de variant sur le produit principal ── */
  document.addEventListener('bisou:variant-change', function (e) {
    if (picks.length) renderCards(e.detail);
  });
})();
